import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { authService } from '../services/firebaseService';

// Composants simplifiés
import SimpleDashboard from '../components/dashboard/SimpleDashboard';
import SimpleAthleteList from '../components/athletes/SimpleAthleteList';
import SimpleTournamentList from '../components/tournaments/SimpleTournamentList';
import SimpleTournamentDetail from '../components/tournaments/SimpleTournamentDetail';
import HomePage from '../components/home/HomePage';

// Composants d'authentification existants
import Login from '../components/users/Login';
import Register from '../components/users/Register';
import UserProfile from '../components/users/UserProfile';
import SimpleSubscriptionPlans from '../components/users/SimpleSubscriptionPlans';

// Composants Stripe
import SimpleStripeCheckout from '../components/stripe/SimpleStripeCheckout';
import SimplePaymentSuccess from '../components/stripe/SimplePaymentSuccess';
import PaymentCancel from '../components/stripe/PaymentCancel';

// Layout
import SimpleNavbar from '../components/layout/SimpleNavbar';

// Route protégée
const ProtectedRoute = ({ children }) => {
  const user = authService.getCurrentUser();
  
  if (!user) {
    // Rediriger vers la page d'accueil publique au lieu de la page de connexion
    return <Navigate to="/home" />;
  }
  
  return children;
};

const SimpleRoutes = () => {
  return (
    <>
      <SimpleNavbar />
      <Routes>
        {/* Routes publiques */}
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        
        {/* Routes protégées */}
        <Route path="/" element={
          <ProtectedRoute>
            <SimpleDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/athletes" element={
          <ProtectedRoute>
            <SimpleAthleteList />
          </ProtectedRoute>
        } />
        
        <Route path="/tournaments" element={
          <ProtectedRoute>
            <SimpleTournamentList />
          </ProtectedRoute>
        } />
        
        <Route path="/tournaments/:id" element={
          <ProtectedRoute>
            <SimpleTournamentDetail />
          </ProtectedRoute>
        } />
        
        <Route path="/profile" element={
          <ProtectedRoute>
            <UserProfile />
          </ProtectedRoute>
        } />
        
        <Route path="/subscription" element={
          <ProtectedRoute>
            <SimpleSubscriptionPlans />
          </ProtectedRoute>
        } />
        
        <Route path="/checkout" element={
          <ProtectedRoute>
            <SimpleStripeCheckout />
          </ProtectedRoute>
        } />
        
        {/* Pages de paiement accessibles sans authentification pour les redirections Stripe */}
        <Route path="/payment-success" element={<SimplePaymentSuccess />} />
        <Route path="/payment-cancel" element={<PaymentCancel />} />
        
        {/* Redirection par défaut */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};

export default SimpleRoutes;
